Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.ListBox = (function () {

    function ListBox () {

        Monet.UI.Fields.Base.apply(this, arguments);

        this.listingEntity = null;

        this.createBaseStructure();

        this.input = null;
        this.value = "";

        this.createElement = function () {
            this.divListBox = document.createElement('div');
            this.divListBox.className = 'container_lookuplist_added container_listbox';
            this.divListBox.id = this.listingEntity.toLowerCase() + '_list';

            this.divListBoxWrapper = document.createElement('div');
            this.divListBoxWrapper.className = 'MonetUIFieldsLookupListItemsWrapper';

            const noItemsText = Monet.I18n.getResourcesByKey("list.noItems");
            const noItemsTextNode = document.createTextNode(noItemsText);
            this.noItems = document.createElement("p");
            this.noItems.className = 'no-items';
            this.noItems.appendChild(noItemsTextNode);

            this.divListBoxWrapper.appendChild(this.noItems);

            this.divListBox.appendChild(this.divListBoxWrapper);
            
            this.rootEl.className = 'listBox';
            this.rootEl.appendChild(this.divListBox);
        };

        this.createItemLookupList = function (id, value) {
            var item = document.createElement('div');
            item.id = id;
            item.className = `zebrado`;

            var description = document.createElement('div');
            description.className = 'title_item_added';
            description.innerHTML = value;

            var divStyle = document.createElement('div');
            divStyle.style.clear = 'both';

            item.appendChild(description);
            item.appendChild(divStyle);

            this.divListBoxWrapper.appendChild(item);

            return item;
        };

        this.getValue = function () {
            if (this.input) {
                this.value = this.input.value;
            }
            return this.value;
        };

        this.setValue = function (items) {
            var transformed = items.map(this.transformModelToJson);
            transformed.length && this.hideNoItems();
            transformed.forEach((item) => {
                var element = this.getValueFromJsonElement(item);

                if (element.id) {
                    const textValue = element[this.displayKey] ? element[this.displayKey] : element["key"];
                    this.createItemLookupList(element.id, textValue);
                }
            });
        };

        this.hideNoItems = function() {
            this.noItems.style.display = 'none';
        };

        this.transformModelToJson = function (model) {
            return (model.attributes) ? model.attributes : model;
        };

        this.getValueFromJsonElement = function (jsonElement) {
            if (this.meta && this.meta.hasMany && this.meta.hasMany.entityName) {
                var nested = jsonElement[this.meta.hasMany.entityName];
                if (nested) {
                    return nested;
                }
            }
            return jsonElement;
        };

        this.setListingEntity = function (entity) {
            this.listingEntity = entity;
        };

        this.render = function () {
            this.createElement();
            return this.rootEl;
        };
    }

    return ListBox;

}());